import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Checkbox, Column, Typography } from 'seagull';
import { useFeatureFlags } from "../../../../../../hooks/useFeatureFlags";
import { getStepName } from "../../../../ClientOnboarding.utils";
import { getVendorGradientStyle } from "../../../ClientOnboardingV2.utils";
import { contentTransition, contentVariants } from "../animations";
import { StepContent } from "../StepContent";
import { GetStepsContainerTID } from "./StepsContainer";
import styles from "./StepsContainerMobile.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepsContainerMobile = _ref => {
  let {
    testId,
    currentStep,
    direction,
    relationship,
    statement,
    isStatementAccepted,
    onStatementChange
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    StepsContainerTestIds
  } = useMemo(() => GetStepsContainerTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  const stepTitle = useMemo(() => getStepName(currentStep, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS)), [currentStep, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS]);
  const showCheckbox = statement && onStatementChange;
  return /*#__PURE__*/_jsx(Box, {
    className: styles.gradientWrapper,
    style: gradientStyle,
    "data-testid": StepsContainerTestIds.Root(),
    children: /*#__PURE__*/_jsx(Column, {
      className: styles.inner,
      children: /*#__PURE__*/_jsx(Column, {
        className: styles.content,
        "data-testid": StepsContainerTestIds.Content(),
        children: /*#__PURE__*/_jsx(AnimatePresence, {
          initial: false,
          mode: "wait",
          custom: direction,
          children: /*#__PURE__*/_jsxs(motion.div, {
            custom: direction,
            variants: contentVariants,
            initial: "enter",
            animate: "center",
            exit: "exit",
            transition: contentTransition,
            className: styles.motionWrapper,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h3",
              weight: "normal",
              className: styles.stepTitle,
              "data-testid": StepsContainerTestIds.StepTitle(),
              children: stepTitle
            }), /*#__PURE__*/_jsx("div", {
              className: styles.stepContent,
              children: /*#__PURE__*/_jsx(StepContent, {
                currentStep: currentStep
              })
            }), showCheckbox && /*#__PURE__*/_jsx("div", {
              className: styles.checkboxWrapper,
              children: /*#__PURE__*/_jsx(Checkbox, {
                className: styles.statementCheckbox,
                onChange: e => onStatementChange(e.target.checked),
                testid: StepsContainerTestIds.Footer() + '-checkbox',
                checked: isStatementAccepted,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph1",
                  weight: "light",
                  children: statement
                })
              })
            })]
          }, currentStep)
        })
      })
    })
  });
};